<app-lex-xi-side-panel
  [panelOpen]="isPanelOpen"
  [isLoading]="isLoading"
  [verticalTabBarData]="[
    {
      id: 'widgetgroups',
      icon: 'list_view',
      hasSeparator: true,
      leftSideTemplate: widgetGroupsList,
      rightSideTemplate: rightSide,
    },
    {
      id: 'comparisons',
      icon: 'search_suggestion_filled',
      hasSeparator: true,
      leftSideTemplate: comparisonsList,
      rightSideTemplate: rightSide,
    },
    {
      id: 'actionPlan',
      icon: 'flag_filled',
      hasSeparator: true,
      leftSideTemplate: actionPlans,
      rightSideTemplate: rightSide,
      features: ['ACTION_PLANS'],
    },
    {
      id: 'savedViews',
      icon: 'saved_views_filled',
      hasSeparator: false,
      leftSideTemplate: savedViewsList,
      rightSideTemplate: rightSide,
      permissions: ['READ_ONLY', 'EXECUTIVE_READ_ONLY'],
      executiveFeatures: ['SPOTLIGHT_ALLOW_SAVED_VIEWS_FOR_EXECUTIVE_VIEW'],
      disabledReasonKey: 'lex-xi-side-panel-component.saved-views-executive-disabled',
    },
  ]"
  [class.side-panel-locked]="!isPanelOpen && dashboardViewComponent?.dashboard?.locked"
  (open)="onPanelStateChange(true)"
  (close)="onPanelStateChange(false)"
></app-lex-xi-side-panel>

<ng-template #widgetGroupsList>
  <ng-container *transloco="let t; prefix: 'dashboard-details-component.widget-group'">
    <app-dashboard-side-pane
      headerText="{{ t('header') }}"
      headerIconTooltip="{{ t('header-icon') }}"
      headerIconUrl="https://spotlight-docs.lexalytics.com/docs/widget-groups"
      addButtonTooltip="{{ t('add-button-tooltip') }}"
      emptyViewText="{{ t('empty-view') }}"
      ctaButtonText="{{ t('cta-button') }}"
      emptyViewTitle="{{ t('cta-button') }}"
      itemType="widgetGroup"
      [itemComponentType]="WidgetGroupSidePaneItemComponent"
      [hasDataSources]="datasourceManagerStore.hasData()"
      [isDisabled]="!!dashboardViewComponent?.dashboard?.locked || selectModeStore.isActive()"
      [isEditable]="canEditWidgetGroup"
      [isDashboardUnsaved]="isDashboardUnsaved"
      [isDashboardLocked]="dashboardViewComponent?.dashboard?.locked"
      [isLoading]="isLoading"
      [currentDashboardPageId]="currentDashboardPageId()"
      [dashboardPages]="dashboardViewComponent?.dashboard?.payload.pages"
      [sentimentScale]="dashboardViewComponent?.dashboard?.payload.sentimentScale"
      [items]="widgetGroupList()"
      (addButtonClick)="createWidgetGroup()"
      (itemAction)="onWidgetGroupAction($event)"
    ></app-dashboard-side-pane>
  </ng-container>
</ng-template>

<ng-template #savedViewsList>
  <ng-container *transloco="let t; prefix: 'dashboard-details-component.saved-views'">
    <app-dashboard-side-pane
      headerText="{{ t('header') }}"
      addButtonTooltip="{{ t('add-button-tooltip') }}"
      emptyViewText="{{ t('empty-view') }}"
      ctaButtonText="{{ t('cta-button') }}"
      emptyViewTitle="{{ t('cta-button') }}"
      searchPlaceholder="{{ t('search') }}"
      emptyMessage="{{ t('empty-message') }}"
      itemType="savedView"
      [itemComponentType]="SavedViewSidePaneItemComponent"
      [hasDataSources]="datasourceManagerStore.hasData()"
      [isDisabled]="!!dashboardViewComponent?.dashboard?.locked || selectModeStore.isActive()"
      [isEditable]="isReadOnly"
      [isDashboardUnsaved]="isDashboardUnsaved"
      [isDashboardLocked]="dashboardViewComponent?.dashboard?.locked"
      [isLoading]="isLoading"
      [currentDashboardPageId]="currentDashboardPageId()"
      [dashboardPages]="dashboardViewComponent?.dashboard?.payload.pages"
      [items]="savedViews"
      (addButtonClick)="onAddSavedView()"
      (itemAction)="onSavedViewAction($event)"
    ></app-dashboard-side-pane>
  </ng-container>
</ng-template>

<ng-template #comparisonsList
  ><ng-container *transloco="let t; prefix: 'dashboard-details-component.comparison-list'">
    <app-dashboard-side-pane
      headerText="{{ t('header') }}"
      addButtonTooltip="{{ t('add-button-tooltip') }}"
      emptyViewText="{{ t('empty-view') }}"
      emptyViewTitle="{{ t('cta-button') }}"
      ctaButtonText="{{ t('cta-button') }}"
      itemType="comparison"
      [itemComponentType]="ComparisonSidePaneItemComponent"
      [hasDataSources]="datasourceManagerStore.hasData()"
      [isDisabled]="!!dashboardViewComponent?.dashboard?.locked || selectModeStore.isActive()"
      [isEditable]="canEditWidgetGroup"
      [isDashboardUnsaved]="isDashboardUnsaved"
      [isDashboardLocked]="dashboardViewComponent?.dashboard?.locked"
      [isLoading]="isLoading"
      [currentDashboardPageId]="currentDashboardPageId()"
      [dashboardPages]="dashboardViewComponent?.dashboard?.payload.pages"
      [items]="comparisonList"
      (addButtonClick)="createComparison()"
      (itemAction)="onComparisonAction($event)"
    ></app-dashboard-side-pane>
  </ng-container>
</ng-template>

<ng-template #actionPlans>
  <ng-container *transloco="let t; prefix: 'dashboard-details-component.action-plan'">
    <app-dashboard-side-pane
      headerText="{{ t('header') }}"
      addButtonTooltip="{{ t('add-button-tooltip') }}"
      emptyViewText="{{ t('empty-view') }}"
      ctaButtonText="{{ t('cta-button') }}"
      itemType="actionPlan"
      [itemComponentType]="ActionPlanSidePaneItemComponent"
      [hasDataSources]="datasourceManagerStore.hasData()"
      [isDisabled]="!!dashboardViewComponent?.dashboard?.locked || selectModeStore.isActive()"
      [isEditable]="canEditWidgetGroup"
      [isDashboardUnsaved]="isDashboardUnsaved"
      [isDashboardLocked]="dashboardViewComponent?.dashboard?.locked"
      [isLoading]="isLoading"
      [currentDashboardPageId]="currentDashboardPageId()"
      [dashboardPages]="dashboardViewComponent?.dashboard?.payload.pages"
      [items]="actionPlanSidePaneDataList"
      [addButtonDisabled]="!isActionPlansAvailable"
      addButtonDisabledTooltip="{{ t('add-button-disabled') }}"
      (addButtonClick)="onAddActionPlan()"
      (itemAction)="onActionPlanAction($event)"
    ></app-dashboard-side-pane>
  </ng-container>
</ng-template>

<ng-template #rightSide>
  <div side="right" class="dashboard-details__dashboard-wrapper">
    <app-dashboard-view
      #dashboardView
      [activeSavedView]="activeSavedView"
      [showSavedViewBanner]="!!activeSavedViewId"
      (widgetGroupRefreshEmit)="onRefreshWidgetGroups($event)"
      (dashboardUnsavedEmit)="onDashboardUnsavedChanged($event)"
      (widgetsCountChanges)="onWidgetsCountChanges($event)"
      (dashboardPageChangedEmit)="onDashboardPageChanged($event)"
      (unsavedPagesEmit)="onUnsavedPagesChanged($event)"
      (setWidgetGroupPanel)="onSetWidgetGroupPanel($event)"
      (onActivitybarInteraction)="onActivitybarInteraction($event)"
      (dashboardParametersChange)="onDashboardParametersChanged($event)"
      (savedViewBannerSave)="onSavedViewBannerSave()"
      (savedViewBannerSaveAs)="onSavedViewBannerSaveAs()"
      (savedViewBannerRevert)="onSavedViewBannerRevert()"
      (savedViewBannerClose)="onSavedViewBannerClose()"
    ></app-dashboard-view>
  </div>
</ng-template>

@if (
  !dashboardViewComponent?.dashboard?.locked && isDashboardUnsaved && !selectModeStore.isActive()
) {
  <div class="dashboard-details__bottom-save-bar">
    <div
      class="dashboard-details__bottom-save-bar-actions"
      *transloco="let t; prefix: 'dashboard-details-component'"
    >
      <div [matTooltip]="unsavedPagesTooltip">
        <xi-icon icon="warning" color="warning"></xi-icon>
        <span class="dashboard-details__bottom-save-bar-warning">{{ t('unsaved-changes') }}</span>
      </div>
      @if (!dashboardViewComponent?.isDashboardNew) {
        <xi-default-button
          text="{{ t('revert-change') }}"
          fill="text"
          [disabled]="isSaving | async"
          (onClick)="revertDashboard()"
        ></xi-default-button>
      }
      @if (dashboardViewComponent?.isDashboardNew) {
        <xi-default-button
          text="{{ t('cancel-new') }}"
          fill="text"
          [disabled]="isSaving | async"
          (onClick)="cancelNewDashboard()"
        ></xi-default-button>
      }
      <div class="xi-loader-button-container">
        <xi-default-button
          text="{{ t('save') }}"
          [disabled]="isSaving | async"
          (onClick)="saveDashboard()"
        ></xi-default-button>
        @if (isSaving | async) {
          <div class="xi-loader-container__inline-overlay">
            <xi-animation
              [height]="75"
              [width]="75"
              [loop]="true"
              animation="cx_loader"
            ></xi-animation>
          </div>
        }
      </div>
    </div>
  </div>
}
@if (showCreateComparison) {
  <app-create-comparison-drawer
    [open]="showCreateComparison"
    [isReadOnly]="isReadOnly"
    [projectId]="projectId"
    [projectColors]="project.colorPalette"
    [pageId]="currentDashboardPageId()"
    [comparison]="selectedComparison"
    [comparisonList]="comparisonList"
    (close)="onCreateComparisonClosed($event)"
  ></app-create-comparison-drawer>
}

<app-lex-xi-modal
  [isVisible]="isSavedViewDialogOpen"
  (close)="onSavedViewDialogClose(null)"
  maxWidth="660px"
>
  <ng-template appXIModalContent>
    @if (isSavedViewDialogOpen) {
      <app-saved-view-create
        [existingNames]="savedViewDialogExistingNames"
        [initialName]="savedViewDialogInitialName"
        [title]="savedViewDialogTitle"
        (close)="onSavedViewDialogClose($event)"
      ></app-saved-view-create>
    }
  </ng-template>
</app-lex-xi-modal>

<app-lex-xi-modal
  [isVisible]="isAddActionPlanDialogOpen"
  (close)="onCloseAddActionPlanDialog(null)"
  maxWidth="1200px"
>
  <ng-template appXIModalContent>
    @if (isAddActionPlanDialogOpen) {
      <app-add-action-plan-dialog
        [selectedIds]="selectedActionPlanIds"
        (close)="onCloseAddActionPlanDialog($event)"
      ></app-add-action-plan-dialog>
    }
  </ng-template>
</app-lex-xi-modal>

<app-lex-xi-modal
  [isVisible]="isWidgetGroupChooserOpen"
  (close)="onCloseWidgetGroupChooser(null)"
  maxWidth="600px"
>
  <ng-template appXIModalContent>
    @if (isWidgetGroupChooserOpen) {
      <app-widget-group-chooser
        [widgetGroups]="widgetGroupsToChoose"
        (close)="onCloseWidgetGroupChooser($event)"
      ></app-widget-group-chooser>
    }
  </ng-template>
</app-lex-xi-modal>

<app-lex-xi-modal
  [isVisible]="isComparisonChooserOpen"
  (close)="onCloseComparisonChooser(null)"
  maxWidth="600px"
>
  <ng-template appXIModalContent>
    @if (isComparisonChooserOpen) {
      <app-comparison-chooser
        [comparisons]="comparisonsToChoose"
        (close)="onCloseComparisonChooser($event)"
      ></app-comparison-chooser>
    }
  </ng-template>
</app-lex-xi-modal>
